import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	newMessage: { padding: "1rem 0" },
}));

export default useStyles;
